import React from "react";
import "./index.scss";
import VideoFeed from "../VideoFeed/src/VideoFeed";

type Props = {
  title?: string;
  playlistId: string;
  videoFeedData?: {
    items: Record<string, unknown>[];
  };
};

export default ({ playlistId, videoFeedData, title }: Props) => {
  return (
    <div className="video-highlights page-section__inner">
      <VideoFeed
        title={title && title.length > 0 ? title : "Latest Highlights"}
        videoFeedData={videoFeedData}
        playlistId={playlistId}
      />
    </div>
  );
};
